import { z } from "zod";

export const IDSchema = z.string().uuid();
export type ID = z.infer<typeof IDSchema>;

export const IDListSchema = z.array(IDSchema);
export type IDList = z.infer<typeof IDListSchema>;

export const IDSetSchema = z.set(IDSchema);
export type IDSet = z.infer<typeof IDSetSchema>;
